import { render, staticRenderFns } from "./secondGuide.vue?vue&type=template&id=3104c80a&scoped=true"
import script from "./secondGuide.vue?vue&type=script&lang=js"
export * from "./secondGuide.vue?vue&type=script&lang=js"
import style0 from "./secondGuide.vue?vue&type=style&index=0&id=3104c80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3104c80a",
  null
  
)

export default component.exports